<template>
	<div>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Konversi Produk</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<router-link class="text-deco" :to="{ name: 'add-product-convert' }" v-if="hasAccess('add-product-convert')">
						<v-btn light depressed class="primary">
							<v-icon>mdi-plus-circle</v-icon>
							<div class="pl-2 text-capitalize">Tambah Konversi Produk</div>
						</v-btn>
					</router-link>
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn text depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2 text-capitalize">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined>
			<v-data-table loading disable-pagination :headers="headers" :items="dataProductConvert" :options.sync="option" :server-items-length="dataProductConvertPagination.total_data" hide-default-footer>
				<template v-slot:item.product_stock_convertion_datetime="{ item }">
					{{ item.product_stock_convertion_datetime | tanggalid }}
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!dataProductConvertPagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5">
			<v-row v-if="dataProductConvertPagination">
				<v-col cols="12" md="11" class="py-0 d-flex justify-end">
					<v-pagination v-model="page" :length="dataProductConvertPagination.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="12" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" @input="changeLimit" v-model="limit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions,  mapState, mapMutations} from 'vuex'
import filterComponent from '@/components/Filter'

export default {
	inject: ['theme'],
	components: {
		filterComponent
	},
	data() {
		return {
			sortBy: 'product_stock_convertion_id',
			sortDir: 'DESC',
			page: 1,
			limit: 10,
			listLimit: [ 10, 10, 20, 50, 100 ],
			paramProp: '',
			val: {},
			edit: 'edit',
			dialog: false,
			dialogConfirm: false,
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Kode', value: 'product_stock_convertion_code'},
			{ text: 'Warehouse', value: 'warehouse_name'},
			{ text: 'Asal Produk', value: 'product_stock_convertion_product_name_from'},
			{ text: 'Tujuan Produk', value: 'product_stock_convertion_product_name_to'},
			{ text: 'Jumlah', value: 'product_stock_convertion_quantity' },
			{ text: 'Tanggal', value: 'product_stock_convertion_datetime'},
			],
			filterData: [{
				type: 'text',
				label: 'Kode',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'product_stock_convertion_code'
				}
			}, {
				type: 'selection',
				label: 'Produk Asal',
				item: [],
				itemValue: 'product_id',
				itemText: 'product_name',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'product_stock_convertion_product_id_from'
				}
			}, {
				type: 'selection',
				label: 'Produk Tujuan',
				item: [],
				itemValue: 'product_id',
				itemText: 'product_name',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'product_stock_convertion_product_id_to'
				}
			}, {
				type: 'date',
				show: false,
				label: 'Tanggal',
				filter: {
					value: [],
					comparison: 'bet',
					type: 'date',
					field: 'product_stock_convertion_datetime'
				}
			},],
			params:[],
			paramStatus : {
				id : '',
				status : ''
			}
		}
	},
	props: {
		desserts: Array,
	},
	computed: {
		...mapState('productList', ['dataProductConvert', 'dataProductConvertPagination', 'productConvert']),
	},
	methods: {
		...mapActions('productList', ['getDataConvertProduct', 'getDataConvertProductWarehouse', 'getProductConvert', 'exportConvertProduct', 'exportConvertProductWarehouse', 'getOptionWarehouse']),
		...mapMutations('productList', ['clearDataProduct']),
		...mapMutations(['setFilter']),

		getData() {
			let params = this.params
			let query = this.queryString({limit:this.limit, page: this.page, params: params, sort: this.sortBy, dir: this.sortDir})
			if (this.$route.name == 'product-convert-warehouse')
				this.getDataConvertProductWarehouse(query)
			else
				this.getDataConvertProduct(query)
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		exportData(){
			let params = this.params
			if (this.$route.name == 'product-convert-warehouse')
				this.exportConvertProductWarehouse(this.queryString({params:params, sort: this.sortBy, dir: this.sortDir}))
			else
				this.exportConvertProduct(this.queryString({params:params, sort: this.sortBy, dir: this.sortDir}))
		},
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Data Konversi Produk`)
		if (this.$route.name == 'product-convert-warehouse') {
			let filter_wh = {
				type: 'selection',
				label: 'Warehouse',
				item: await this.getOptionWarehouse(),
				itemValue: 'warehouse_id',
				itemText: 'warehouse_name',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'product_stock_convertion_warehouse_id'
				}
			}
			this.filterData.push(filter_wh)
		}

		await this.getProductConvert(this.queryString({limit:100}))
		let indexFrom = await this.filterData.findIndex(el => el.label == 'Produk Asal')
		let indexTo = await this.filterData.findIndex(el => el.label == 'Produk Tujuan')
		this.filterData[indexFrom].item = this.productConvert
		this.filterData[indexTo].item = this.productConvert
		await this.setFilter(this.filterData)
		await this.getData()
	},
	beforeDestroy() {
		this.clearDataProduct()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
}
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>